import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FileUploadModule } from 'src/app/common-components/file-upload/file-upload.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AddPromptComponent } from './containers/add-prompt.component';
import { AddPromptEffects } from './state/add-prompt.effects';
import * as fromAddPrompt from './state/add-prompt.reducer';
import { AddPromptViewComponent } from './views/add-prompt-view.component';
@NgModule({
   declarations: [AddPromptComponent, AddPromptViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonToggleModule,
      FileUploadModule,
      MatButtonModule,
      AddSpacesPipeModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      MatCardModule,
      EntitySelectModule,
      LcsDatepickerModule,
      StoreModule.forFeature(fromAddPrompt.addPromptFeatureKey, fromAddPrompt.reducer),
      EffectsModule.forFeature([AddPromptEffects]),
   ],
})
export class AddPromptModule {}
